import { createAction, props } from '@ngrx/store';
import { SubmittalRegistryFilterParams } from '@app/store/submittals/submittals.types';

const submittalRegistryPageOpened = createAction(
  '[Submittals Registry Listing] Page Opened',
  props<{ projectId: number }>(),
);

const submittalRegistryFiltersChanged = createAction(
  '[Submittals Registry Listing] Filters Changed',
  props<{ projectId: number; filters: Partial<SubmittalRegistryFilterParams> }>(),
);

const loadNextSubmittalRegistryPage = createAction(
  '[Submittals Registry Listing] Page Reached End',
  props<{ projectId: number }>(),
);

const createRevisionForRegistryItems = createAction(
  '[Submittals Registry Listing] Create Revision For Registry Items',
  props<{ registryIds: number[] }>(),
);

const deleteSubmittalRegistryItem = createAction(
  '[Submittals Registry Listing] Delete Submittal Registry Item',
  props<{ registryIds: number[] }>(),
);

const assignOwnerToRegistries = createAction(
  '[Submittals Registry Listing] Bulk assign registry owner triggered',
  props<{ registryIds: number[]; owner_id: number }>(),
);

const removePackageFromRegistry = createAction(
  '[Submittals Registry Listing] Remove Package From Registry',
  props<{ registryIds: number[] }>(),
);

export const submittalRegistryListingActions = {
  submittalRegistryPageOpened,
  submittalRegistryFiltersChanged,
  loadNextSubmittalRegistryPage,
  createRevisionForRegistryItems,
  deleteSubmittalRegistryItem,
  assignOwnerToRegistries,
  removePackageFromRegistry,
};
